import Image, { ImageProps } from "next/image";
import logo from "@/public/logo.svg";

export default function Logo(props: Omit<ImageProps, "src" | "alt">) {
  return <Image {...props} src={logo} alt="Holloway Storage Logo" />;
}
